<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Introductory Information</h2>
      </v-row>

      <v-simple-table>
        <thead>
          <tr v-for="field in fields" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'OleMiss116ExperimentInfo',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        date: null,
        group: null,
      },
      fields: [
        {name: 'Experiment Title:', inputKey: 'title'},
        {name: 'Date Experiment Performed: ', inputKey: 'date'},
        {name: 'Group Members: ', inputKey: 'group'},
      ],
    };
  },
};
</script>

<style scoped></style>
